import apiService from "../../../service/Api";
import type {
  AddLineItemPayload,
  CostAnalysisDetail,
  SubmitTarget,
} from "./cost-analysis";

// TODO: move these two payload types into ./cost-analysis.ts, next to
// AddLineItemPayload, once that file's on hand — kept local here so this
// compiles standalone in the meantime.
export interface UpdateLineItemPayload {
  label: string;
  amount: number;
}

export interface DeleteLineItemPayload {
  item_id: number;
}

export async function fetchCostAnalysis(
  streamId: number | string,
): Promise<CostAnalysisDetail> {
  const res = await apiService.get<CostAnalysisDetail>(
    `/api/cost-analysis/cost-analyses/by-stream/${streamId}/`,
  );
  return res.data;
}

export async function recalculateCostAnalysis(
  id: number | string,
): Promise<CostAnalysisDetail> {
  const res = await apiService.post<CostAnalysisDetail>(
    `/api/cost-analysis/cost-analyses/${id}/recalculate/`,
  );
  return res.data;
}

export async function addLineItem(
  id: number | string,
  payload: AddLineItemPayload,
): Promise<CostAnalysisDetail> {
  const res = await apiService.post<CostAnalysisDetail>(
    `/api/cost-analysis/cost-analyses/${id}/add-line-item/`,
    payload,
  );
  return res.data;
}

export async function updateLineItem(
  id: number | string,
  itemId: number,
  payload: UpdateLineItemPayload,
): Promise<CostAnalysisDetail> {
  const res = await apiService.patch<CostAnalysisDetail>(
    `/api/cost-analysis/cost-analyses/${id}/line-items/${itemId}/`,
    payload,
  );
  return res.data;
}

export async function deleteLineItem(
  id: number | string,
  itemId: number,
): Promise<CostAnalysisDetail> {
  const res = await apiService.post<CostAnalysisDetail>(
    `/api/cost-analysis/cost-analyses/${id}/delete-line-item/`,
    { item_id: itemId } satisfies DeleteLineItemPayload,
  );
  return res.data;
}

export async function submitCostAnalysis(
  id: number | string,
  target: SubmitTarget,
): Promise<CostAnalysisDetail> {
  const res = await apiService.post<CostAnalysisDetail>(
    `/api/cost-analysis/cost-analyses/${id}/submit/`,
    { submitted_to: target },
  );
  return res.data;
}
